export default __webpack_public_path__ + "static/media/CNo.15-2.9cbbdb0d.jpg";